import $ from './jquery-shim.js';
import OptimizedMousewheelHandler from './optimizedMousewheelHandler.js';


export default class Fullpage {

  constructor() {
    this.init();
  }

  // 初期化
  init() {
    this.$fullsections = $('.js-full-sections');
    this.$sections = $('.js-full-section');
    this.currentSectionIndex = 0;
    this.currentSectionId = this.getCurrentSection().attr('id');
    this.maxSectionNum = this.$sections.length;
    this.$scrollNav = $('.js-scrollnav');
    this.pagetopClickFlag = true;
    this.scrollNav(this.currentSectionId);
    this.watch();
    this.scrollNavClick();
    this.watchRelisten = this.watchRelisten.bind(this);
    this.watchRelisten();
    this.sessionReload();
    this.watchScroll = this.watchScroll.bind(this);
    this.watchScroll();
    this.resetReload();
    this.reset();
  }

  // スクロールを監視する
  watch() {
    this.wheelhandler = new OptimizedMousewheelHandler($('.js-full-sections'));
    this.wheelhandler.addCallback((delta) => {
      if (delta === 1) {
        this.nextSection();
      } else {
        this.prevSection();
      }
    });
    this.getCurrentSection().addClass('is-active');
    this.wheelhandler.startListen();
  }

  // 再帰的にスクロール制御を開始する
  watchRelisten() {
    let $firstSection = this.$sections[0];
    let $lastSection = this.$sections[this.maxSectionNum - 1];
    let $sectionHeight = $($lastSection).innerHeight() - 100;
    let $firstSectionTop = $($firstSection).offset().top;
    let $firstSectionBottom = $firstSectionTop + $sectionHeight;
    let $lastSectionTop = $($lastSection).offset().top;
    let $lastSectionBottom = $lastSectionTop + $sectionHeight;
    var now = this.currentSectionIndex;
    if (this.wheelhandler.locked === false && window.pageYOffset <= $firstSectionBottom && window.pageYOffset > $firstSectionTop && now === 0) {
      this.wheelhandler.startListen();
    }
    if (this.wheelhandler.locked === false && window.pageYOffset < $lastSectionTop && now === this.maxSectionNum - 1) {
      this.wheelhandler.startListen();
    }
    window.requestAnimationFrame(this.watchRelisten);
  }

  // スクロールを許可しない
  sectionLock() {
    this.wheelhandler.locked = true;
  }

  // スクロールを許可する
  sectionUnLock() {
    this.wheelhandler.locked = false;
  }

  // クリックしたスクロールナビにクラスを付与する
  scrollNav(currentSectionId) {
    this.$scrollNav.find('a').removeClass('is-current');
    this.$scrollNav.find('a[href="#' + currentSectionId + '"]').addClass('is-current');
  }


  // スクロールナビをクリックした時の動作
  scrollNavClick() {
    this.scrollNavClickFlag = false;
    this.$scrollNav.on('click', 'a', (e) => {
      e.preventDefault();
      if (this.scrollNavClickFlag === true) {
        return true;
      }
      this.scrollNavClickFlag = true;
      var $link = $(e.currentTarget);
      let targetId = $link.attr('href');
      var $currentSection = this.getCurrentSection();
      let $target = $(targetId);
      var currentIndex = 0;
      for (var i = 0; i < this.$sections.length; i++) {
        if ($(this.$sections[i]).attr('id') == $target.attr('id')) {
          currentIndex = i;
          continue;
        }
      }

      this.currentSectionIndex = currentIndex;
      this.currentSectionId = $target.attr('id');
      $currentSection.removeClass('is-active');
      this.changeSection(this.currentSectionIndex, this.currentSectionIndex);
      setTimeout(() => {
        this.scrollNavClickFlag = false;
      }, 900);
    });
  }

  // 特定のセクションの取得
  getSection(key) {
    return $(this.$sections[key]);
  }

  // 現在表示されているセクションの取得
  getCurrentSection() {
    let $current = $(this.$sections[this.currentSectionIndex]);
    this.currentSectionId = $current.attr('id');
    return $current;
  }

  // 下に動く
  nextSection() {
    var now = this.currentSectionIndex;
    if (now === this.maxSectionNum - 1) {
      this.sectionUnLock();
      this.wheelhandler.endListen();
      return false;
    }
    var next = this.currentSectionIndex + 1;
    this.currentSectionIndex++;
    this.changeSection(now, next);
  }


  // 上に動く
  prevSection() {
    var now = this.currentSectionIndex;
    if (now === 0) {
      this.sectionUnLock();
      this.wheelhandler.endListen();
      return false;
    }
    var prev = this.currentSectionIndex - 1;
    this.currentSectionIndex--;
    this.changeSection(now, prev);
  }


  // セクションを切り替える処理
  changeSection(currentKey, key) {
    var $currentSection = this.getSection(currentKey);
    var $targetSection = this.getSection(key);
    this.sectionLock();
    this.saveSession();
    this.scrollNav($targetSection.attr('id'));
    $currentSection.addClass('is-active');
    setTimeout(() => {
      $currentSection.removeClass('is-active');
      $targetSection.addClass('is-active');
      if ($targetSection.offset() != undefined) {
        $('body, html').animate({
          scrollTop: $targetSection.offset().top
        }, 0);
      }
    }, 0);
    setTimeout(() => {
      this.sectionUnLock();
    }, 1000);
  }


  // セッションに最後の開いていたセクションを記録する
  saveSession() {
    sessionStorage.setItem('sectionId', this.currentSectionIndex);
  }

  sessionReload() {
    var $lastSection = this.getSection(0);
    let $currentNum = sessionStorage.getItem('sectionId');
    if ($currentNum) {
      let $currentSection = this.getSection($currentNum);
      this.currentSectionIndex = Number($currentNum);
      let $current = $(this.$sections[this.currentSectionIndex]);
      $lastSection.removeClass('is-active');
      this.currentSectionId = $current.attr('id');
      this.scrollNav(this.currentSectionId);
      $currentSection.addClass('is-active');
    }
  }

  resetReload() {
    var self = this;
    if (window.pageYOffset === 0) {
      self.currentSectionIndex = 0;
      var $currentSection = self.getSection(self.currentSectionIndex);
      self.scrollNav('section_01');
      self.$sections.removeClass('is-active');
      $currentSection.addClass('is-active');
    }
  }

  reset() {
    var self = this;
    $('.l-footer__pagetop').on('click', function() {
      $('html,body').animate({
        scrollTop: 0
      },1000 );
      self.currentSectionIndex = 0;
      var $lastSection = self.getSection(self.maxSectionNum - 1);
      var $currentSection = self.getSection(self.currentSectionIndex);
      self.scrollNav('section_01');
      $lastSection.removeClass('is-active');
      $currentSection.addClass('is-active');
    });
  }


  // 慣性スクロールを指定の位置で停止する
  watchScroll() {
    if (window.innerWidth <= 950) {
      return false;
    }
    if (this.sectionRect(document.getElementById("section_01")).top <= 0 && this.currentSectionIndex === 0 && this.pagetopClickFlag === true) {
      this.stopScroll('#section_01');
    }
    if (this.sectionRect(document.getElementById("section_03")).top > 0 && this.currentSectionIndex === 2 && this.pagetopClickFlag === true) {
      this.stopScroll('#section_03');
    }

    window.requestAnimationFrame(this.watchScroll);
  }

  // 慣性スクロールを停止する処理
  stopScroll(section) {
    // 現在のスクロール量
    var sectionHeight = $(section).offset().top;
    $('html,body').animate({
      scrollTop: sectionHeight
    },0);
  }

  // 要素の相対的な位置情報を取得
  sectionRect(section) {
    return section.getBoundingClientRect();
  }
}
